// Public script of the Layout block designs (assets/js/event_module_variants.js), loaded on event pages next to
// event_module_variants.css (app/Views/header.php).
import { initCountdowns } from './modules/rem-countdown.js';
import { initFilters } from './modules/rem-filter.js';
import { initScrollers } from './modules/rem-scroller.js';
import { initPagers } from './modules/rem-pager.js';
import { initTabs } from './modules/rem-tabs.js';
import { initContactForms } from './modules/rem-contact-form.js';

const ready = (callback) => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
        return;
    }

    callback();
};

ready(() => {
    initPagers(document);
    initCountdowns(document);
    initFilters(document);
    initScrollers(document);
    initTabs(document);
    initContactForms(document);
});
